import { HourlyForecastChartTypes, HourlyForecastPeriodCompact, ToggleMobileHourlyCardDetailsType } from '../../components/forecasts/common/types';
import { forecastHourSlug } from '../../components/forecasts/common/utils';

export const TOGGLE_MOBILE_HOURLY_CARD_DETAILS = 'TOGGLE_MOBILE_HOURLY_CARD_DETAILS';
export const GET_NEXT_12_HOURS = 'GET_NEXT_12_HOURS';
export const GOTO_DAYS_HOURLY_FORECAST_CARD = 'GOTO_DAYS_HOURLY_FORECAST_CARD';
export const RESET_HOURLY_FORECAST_DATA = 'RESET_HOURLY_FORECAST_DATA';
export const SET_LAST_HOUR_CARD_INDEX_LOADED = 'SET_LAST_HOUR_CARD_INDEX_LOADED';
export const SELECT_HOURLY_FORECAST_CHART = 'SELECT_HOURLY_FORECAST_CHART';

export type GetNext12HoursForecastType = {
    type: typeof GET_NEXT_12_HOURS;
    payload?: any;
}

export type GoToDaysHoursType = {
    cardIndex: number;
    next12HoursMaxIndexRange: number;
}

export type GotoDaysHourlyForecastCardType = {
    type: typeof GOTO_DAYS_HOURLY_FORECAST_CARD;
    payload: GoToDaysHoursType;
}

export type ResetHourlyForecastDataActionType = {
    type: typeof RESET_HOURLY_FORECAST_DATA;
    payload?: any;
}

export type ToggleMobileHourlyCardDetailsActionType = {
    type: typeof TOGGLE_MOBILE_HOURLY_CARD_DETAILS;
    payload: ToggleMobileHourlyCardDetailsType;
}

export type LastHourCardLoadStatusType = {
    type: typeof SET_LAST_HOUR_CARD_INDEX_LOADED;
    payload: number;
}

export type SelectHourylyForecastChartType = {
    type: typeof SELECT_HOURLY_FORECAST_CHART;
    payload: keyof typeof HourlyForecastChartTypes;
}

export function toggleExpandMobileHourlyCard(selectedCardsRecord: ToggleMobileHourlyCardDetailsType): ToggleMobileHourlyCardDetailsActionType {
    
    return {
        type: TOGGLE_MOBILE_HOURLY_CARD_DETAILS,
        payload: selectedCardsRecord
    };
}

export function getNext12HoursForecast(): GetNext12HoursForecastType {
    return {
        type: GET_NEXT_12_HOURS
    };
}


export function resetHourlyForecastDataAction(): ResetHourlyForecastDataActionType {
    return {
        type: RESET_HOURLY_FORECAST_DATA
    };
}

export function gotoDaysHourlyForecastCards(cardIndex: number, next12HoursMaxIndexRange: number): GotoDaysHourlyForecastCardType {
    const payload: GoToDaysHoursType = {
        cardIndex,
        next12HoursMaxIndexRange
    };

    return {
        type: GOTO_DAYS_HOURLY_FORECAST_CARD,
        payload
    };
}

export function autoscrollTo10DayHourURLParamAction(tenDayHourParam: string): any {
    return (dispatch: any, getState: any) => {
        const currState = getState();
        const { apiHourlyForecastPeriods } = currState?.hourlyForecastPage || {};

        const gotoToNext12Hours = true;
        if (tenDayHourParam && gotoToNext12Hours && apiHourlyForecastPeriods?.length) {
            let next12HoursStartIndex = 0;
            let next12HoursEndIndex = 18;
            let cardIndex = 0;
            const total12HoursChunks = Math.round(apiHourlyForecastPeriods.length / 12);
            for (let index = 0; index < total12HoursChunks; index++) {
                const currData = apiHourlyForecastPeriods?.slice(next12HoursStartIndex, next12HoursEndIndex);
                const cardSlugIsInChunk = currData?.some((hourlyForecastPeriod: HourlyForecastPeriodCompact, index: number) => {
                    const hourSlug = forecastHourSlug(hourlyForecastPeriod?.fdtolcl);
                    if (tenDayHourParam === hourSlug) {
                        cardIndex = next12HoursStartIndex + index;
                        return true;
                    }
                    return false;
                });
                
                if (cardSlugIsInChunk) {
                    const indexDiff = next12HoursEndIndex - cardIndex;
                    const endIndex = indexDiff < 11 ? cardIndex + 12 : next12HoursEndIndex;
                    dispatch(gotoDaysHourlyForecastCards(cardIndex, endIndex));
                    break;
                }
                next12HoursStartIndex += 12;
                next12HoursEndIndex += 18;
            }
        }
    };
}

export function lastHourCardLoadComplete(lastHourCardIndex: number): LastHourCardLoadStatusType {
    return {
        type: SET_LAST_HOUR_CARD_INDEX_LOADED,
        payload: lastHourCardIndex
    };
}

export function selectHourlyForecastChart(selectedChart: keyof typeof HourlyForecastChartTypes): SelectHourylyForecastChartType {
    return {
        type: SELECT_HOURLY_FORECAST_CHART,
        payload: selectedChart
    };
}